const { batchDeleteDocuments } = require('api/Documents');
const { showAlert } = require('components/shared/Alert/Alert');
const { ia } = require('lib/helpers/utility');

export default async function batchDelete({
  navigate,
  queryClient,
  selectedItems,
  setSelectedRows,
  setDeleteConfirmation
}) {
  const res = await batchDeleteDocuments(navigate, { documents: selectedItems });

  const selectedIds = selectedItems.map((item) => item.id);

  if (ia(res?.data)) {
    showAlert({
      title: 'Documents deleted successfully',
      color: 'success'
    });
    queryClient.setQueriesData(['practice-documents'], (old) => {
      return {
        ...old,
        documents: old?.documents?.filter((doc) => !selectedIds.includes(doc.id))
      };
    });

    const patientIds = [...new Set(res?.data?.map((doc) => doc?.patient_id))]?.filter(Boolean);

    patientIds.forEach((id) => {
      queryClient.setQueriesData(['chart-documents', id], (old) => {
        return {
          ...old,
          documents: old?.documents?.filter((doc) => !selectedIds.includes(doc.id))
        };
      });
    });

    const appointmentIds = [...new Set(res?.data?.map((doc) => doc?.appointment_id))]?.filter(
      Boolean
    );

    appointmentIds.forEach((id) => {
      queryClient.setQueriesData(['attachment-documents', id.toString()], (old) => {
        return {
          ...old,
          documents: old?.documents?.filter((doc) => !selectedIds.includes(doc.id))
        };
      });
    });
  } else {
    showAlert({
      title: 'Failed to delete documents',
      color: 'danger'
    });
  }

  setSelectedRows([]);
  setDeleteConfirmation(false);
}
